import React from "react";
import CountUp from "react-countup";
import AppDownloadsComponent from "./AppDownloadsComponent";
import { useLocation } from "react-router-dom";

const NumberIncrementVideoComponent = () => {

      const location = useLocation();
  
  
  return (
    <div>

      <div className="increment">

        <h2 className="new-headline-of-incrment-vd-section "> Doorstep Men’s Grooming,  Male-to-Male, Delhi NCR</h2>

                <h2 className="new-sm-headline-of-incrment-vd-section"> Doorstep Men’s Grooming, <br/> Male-to-Male, Delhi NCR</h2>


                                                    {/* <div id="services"></div> */}

    <div>

        <div className="increment-list">

          <div className="increment-list-col">
            {/* <div className="increment-list-col-head"><span><img src={img4} alt="img" /> &nbsp; <CountUp end={10} duration="4" enableScrollSpy /> +</span></div> */}
            <div className="increment-list-col-head" ><span> &nbsp; <CountUp end={10} duration="4" enableScrollSpy /> +</span></div>
            <div className="increment-list-col-text">Years Of Experience</div>
          </div>


          <div className="increment-list-col">
            {/* <div className="increment-list-col-head"><span><img src={img1} alt="img" /> &nbsp; <CountUp end={15} duration="4" enableScrollSpy /> +</span></div> */}
            <div className="increment-list-col-head"><span> &nbsp; <CountUp end={15} duration="4" enableScrollSpy /> +</span></div>
            <div className="increment-list-col-text"  >Available Cities</div>
          </div>


          <div className="increment-list-col">
            {/* <div className="increment-list-col-head"><span><img src={img3} alt="img" /> &nbsp; <CountUp end={100} duration="4" enableScrollSpy /> +</span></div> */}
            <div className="increment-list-col-head"><span> &nbsp; <CountUp end={100} duration="4" enableScrollSpy /> +</span></div>
            <div className="increment-list-col-text"  >Beauty Expert</div>
          </div>


          <div className="increment-list-col"  >
            {/* <div className="increment-list-col-head"><span><img src={img2} alt="img" /> &nbsp; <CountUp end={50000} duration="4" enableScrollSpy /> +</span></div> */}
            <div className="increment-list-col-head"><span> &nbsp; <CountUp end={100000} duration="4" enableScrollSpy /> +</span></div>
            <div className="increment-list-col-text"  >Happy Customers</div>
          </div>

        </div>



        {
        location.pathname === "/"?
        <AppDownloadsComponent />
      :""}
        
      
        
      </div>
    </div>


    </div>
  );
};

export default NumberIncrementVideoComponent;

// export default NumberIncrementVideoComponent